import { lazy } from 'react'
import MainLayout from 'src/layout/MainLayout'
import Loadable from 'src/ui-component/Loadable'
import AuthGuard from 'src/utils/route-guard/AuthGuard'
import SuperadminGuard from 'src/utils/route-guard/SuperadminGuard'
import { Outlet } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { PageDeviceProvider } from 'src/views/page/PageDeviceContext'

const PagePreview = Loadable(lazy(() => import('src/views/page/PagePreview')))
const FormPreview = Loadable(lazy(() => import('src/views/form/FormPreview')))
const SpaceInvite = Loadable(lazy(() => import('src/views/space/Invite')))

const FormList = Loadable(lazy(() => import('src/views/form/FormList')))
const SubscriptionList = Loadable(lazy(() => import('src/views/subscription/SubscriptionList')))
const CoursesList = Loadable(lazy(() => import('src/views/courses/CoursesList')))
const AddChapterToCourse = Loadable(lazy(() => import('src/views/courses/course-chapter')))
const AddMembersToSubscription = Loadable(lazy(() => import('src/views/subscription/membership-packages')))
const SubscribeFieldEditor = Loadable(lazy(() => import('src/views/subscription/SubscribeFieldEditor')))
const CreateForm = Loadable(lazy(() => import('src/views/form/CreateUpdateForm')))
const FormRecord = Loadable(lazy(() => import('src/views/form/FormRecord')))

const PageList = Loadable(lazy(() => import('src/views/page/PageList')))
const CreatePageNew = Loadable(lazy(() => import('src/views/page/CreateUpdatePage')))
// const CreatePage = Loadable(lazy(() => import('src/views/page/CreateUpdatePage_old')))
const CreatePage = Loadable(lazy(() => import('src/views/page/CreateUpdatePage')))
const SEODashboard = Loadable(lazy(() => import('src/views/seo-geo/SEODashboard')))
const CreateUpdatePartner = Loadable(lazy(() => import('src/views/partners/CreateUpdate')))
const Spaces = Loadable(lazy(() => import('src/views/superadmin/spaces/List')))
const SpaceTemplatesList = Loadable(lazy(() => import('src/views/superadmin/space-templates/List')))
const SectionTemplatesList = Loadable(lazy(() => import('src/views/superadmin/section-templates/List')))
const Blocks = Loadable(lazy(() => import('src/views/superadmin/blocks/List')))
const UpdateBlock = Loadable(lazy(() => import('src/views/superadmin/blocks/Update')))
const ExclusiveBlocks = Loadable(lazy(() => import('src/views/exclusive-blocks/List')))
const UpdateExclusiveBlocks = Loadable(lazy(() => import('src/views/exclusive-blocks/Update')))
const CustomerList = Loadable(lazy(() => import('src/views/superadmin/customers/CustomersList')))
const EditCustomer = Loadable(lazy(() => import('src/views/superadmin/customers/EditCustomer')))
const BlockList = Loadable(lazy(() => import('src/views/superadmin/blocks-data/List')))
const Edit = Loadable(lazy(() => import('src/views/superadmin/blocks-data/Edit')))

const TemplateList = Loadable(lazy(() => import('src/views/template/TemplateList')))
const CreateTemplate = Loadable(lazy(() => import('src/views/template/CreateUpdateTemplate')))

const AnalyticsPage = Loadable(lazy(() => import('src/views/analytics')))
const TransactionsPage = Loadable(lazy(() => import('src/views/transactions')))
const AssetsPage = Loadable(lazy(() => import('src/views/assets')))
const DashboardPage = Loadable(lazy(() => import('src/views/dashboard')))
const ListingList = Loadable(lazy(() => import('src/views/listing/ProductList')))
const CreateListing = Loadable(lazy(() => import('src/views/listing/CreateUpdateProduct')))
const ProductList = Loadable(lazy(() => import('src/views/product/ProductList')))
const CreateProduct = Loadable(lazy(() => import('src/views/product/CreateUpdateProduct')))
const CreateDataset = Loadable(lazy(() => import('src/views/dataset/CreateUpdate')))
const DatasetList = Loadable(lazy(() => import('src/views/dataset/List')))
const CreateProductDataset = Loadable(lazy(() => import('src/views/product-dataset/CreateUpdate')))
const ProductDatasetList = Loadable(lazy(() => import('src/views/product-dataset/List')))
const Feed = Loadable(lazy(() => import('src/views/dataset/Feed')))
const SettingsPage = Loadable(lazy(() => import('src/views/settings/GeneralTab')))
const Styling = Loadable(lazy(() => import('src/views/settings/Styling')))
const TagsPage = Loadable(lazy(() => import('src/views/tag/List')))
const CreateTag = Loadable(lazy(() => import('src/views/tag/CreateUpdate')))
const CreatAiPrompt = Loadable(lazy(() => import('src/views/ai-prompts/CreateUpdate')))
const Members = Loadable(lazy(() => import('src/views/members/List')))
const PartnersList = Loadable(lazy(() => import('src/views/partners/List')))
const EditMember = Loadable(lazy(() => import('src/views/members/CreateUpdate')))
// const HeaderList = Loadable(lazy(() => import('src/views/navigation/header/List')))
const CreateUpdateHeader = Loadable(lazy(() => import('src/views/navigation/header/CreateUpdateHeader')))
const NavigationList = Loadable(lazy(() => import('src/views/navigation/List')))
const CreateUpdateFooter = Loadable(lazy(() => import('src/views/navigation/footer/CreateUpdateFooter')))
// const SidebarList = Loadable(lazy(() => import('src/views/navigation/sidebar/List')))
const CreateUpdateSidebar = Loadable(lazy(() => import('src/views/navigation/sidebar/CreateUpdateSidebar')))
const SpaceList = Loadable(lazy(() => import('src/views/space/List')))
const UserList = Loadable(lazy(() => import('src/views/users/userList')))
const EditUser = Loadable(lazy(() => import('src/views/users/EditUser')))
const NewsletterList = Loadable(lazy(() => import('src/views/newsletter/List')))
const CommunicationList = Loadable(lazy(() => import('src/views/communication/List')))
const Organization = Loadable(lazy(() => import('src/views/organization')))
const Onboarding = Loadable(lazy(() => import('src/views/onboarding')))
const PlansAndPricing = Loadable(lazy(() => import('src/views/superadmin/plans')))
// const Index = Loadable(lazy(() => import('src/views/index/Home')))
// const AuthLogin = Loadable(lazy(() => import('src/views/authentication/authentication3/Login3')))
// const AuthRegisterInfo = Loadable(lazy(() => import('src/views/authentication/authentication3/RegisterInfo')))
const CreateNewsletter = Loadable(lazy(() => import('src/views/newsletter/CreateUpdate')))
const CreateCommunication = Loadable(lazy(() => import('src/views/communication/CreateUpdate')))
const Recipients = Loadable(lazy(() => import('src/views/newsletter/Recipients')))
const Triggers = Loadable(lazy(() => import('src/views/communication/Triggers')))

const SignUp = Loadable(lazy(() => import('src/views/authentication/authentication3/SignUp')))
const SignIn = Loadable(lazy(() => import('src/views/authentication/authentication3/SignIn')))
const NewsletterSetting = Loadable(lazy(() => import('src/views/settings/NewsletterSettings')))
// const MemberSetting = Loadable(lazy(() => import('src/views/settings/AddRole')))
const Seo = Loadable(lazy(() => import('src/views/settings/SEOTab')))
const Integration = Loadable(lazy(() => import('src/views/settings/IntegrationsTab')))
const AiPromptsPage = Loadable(lazy(() => import('src/views/ai-prompts/List')))

const StructuredDataAgent = Loadable(lazy(() => import('src/views/structuredDataAgent/Home')))
const ContentAgent = Loadable(lazy(() => import('src/views/contentAgent/Home')))
const ContentAgentListing = Loadable(lazy(() => import('src/views/listing/ContentAgent')))
const CreateScouting = Loadable(lazy(() => import('src/views/agents/scouting/Create')))
const Superbrain = Loadable(lazy(() => import('src/views/agents/scouting/Superbrain')))
// const ContentMachine = Loadable(lazy(() => import('src/views/contentPlanner/Home')))
const ContentPlanner = Loadable(lazy(() => import('src/views/listing/ContentPlanner')))

const LayoutAdminRoutes: RouteObject[] = [
    {
        path: '/organization',
        element: <Organization />
    },
    {
        path: '/space/list',
        element: <SpaceList />
    },
    {
        path: '/user/list',
        element: <UserList />
    },
    {
        path: '/user/:action/:id',
        element: <EditUser />
    },
    {
        path: '/superadmin/blocks',
        element: <Blocks />
    },
    {
        path: '/superadmin/blocks/edit/:id',
        element: <UpdateBlock />
    },
    {
        path: '/superadmin/spaces/list',
        element: <Spaces />
    },
    {
        path: '/exclusive-blocks/edit/:id',
        element: <UpdateExclusiveBlocks />
    },
    {
        path: '/exclusive-blocks',
        element: <ExclusiveBlocks />
    },
    {
        path: '/superadmin/space-template/list',
        element: <SpaceTemplatesList />
    },
    {
        path: '/superadmin/section-template/list',
        element: <SectionTemplatesList />
    },
    {
        path: '/superadmin/customer/list',
        element: <CustomerList />
    },
    {
        path: '/superadmin/customer/edit/:id',
        element: <EditCustomer />
    },
    {
        path: '/superadmin/blocks-data/list',
        element: <BlockList />
    },
    {
        path: '/superadmin/plans',
        element: <SuperadminGuard><PlansAndPricing /></SuperadminGuard>
    }
]

const LayoutSpaceRoutes: RouteObject[] = [
    {
        path: '/form/list',
        element: <FormList />
    },
    {
        path: '/form/record/:id',
        element: <FormRecord />
    },
    {
        path: '/page/list',
        element: <PageList />
    },
    {
        path: '/structured-data-agent',
        element: <StructuredDataAgent />
    },
    {
        path: '/content-planner',
        element: <ContentPlanner />
    },
    {
        path: '/content-planner/edit/:id',
        element: <ContentPlanner />
    },
    {
        path: '/content-agent',
        element: <ContentAgent />
    },
    {
        path: '/partner/list',
        element: <PartnersList />
    },
    {
        path: '/newsletter/recipients/:id',
        element: <Recipients />
    },
    {
        path: '/communication/triggers/:id',
        element: <Triggers />
    },
    {
        path: '/config/template/list',
        element: <TemplateList />
    },
    {
        path: '/listing/list',
        element: <ListingList />
    },
    {
        path: '/product/list',
        element: <ProductList />
    },
    {
        path: '/transactions',
        element: <TransactionsPage />
    },
    {
        path: '/analytics',
        element: <AnalyticsPage />
    },
    {
        path: '/dataset/list',
        element: <DatasetList />
    },
    {
        path: '/product-dataset/list',
        element: <ProductDatasetList />
    },
    {
        path: '/config/tag/list',
        element: <TagsPage />
    },
    {
        path: '/member/list',
        element: <Members />
    },
    {
        path: '/config/assets',
        element: <AssetsPage />
    },
    {
        path: '/config/styling',
        element: <Styling />
    },
    {
        path: '/config/navigation/list',
        element: <NavigationList />
    },
    {
        path: '/newsletter/list',
        element: <NewsletterList />
    },
    {
        path: '/config/communication/list',
        element: <CommunicationList />
    },
    {
        path: '/config/general',
        element: <SettingsPage />
    },
    {
        path: '/config/newsletter',
        element: <NewsletterSetting />
    },
    {
        path: '/config/seo',
        element: <Seo />
    },
    // {
    //     path: '/config/membership',
    //     element: <MemberSetting />
    // },
    {
        path: '/config/subscription',
        element: <SubscriptionList />
    },
    {
        path: '/config/courses',
        element: <CoursesList />
    },
    {
        path: '/config/integrations',
        element: <Integration />
    },
    {
        path: '/config/aiprompt/list',
        element: <AiPromptsPage />
    }
]

// Reachable with and without a selected space
const LayoutCommonRoutes: RouteObject[] = [
    {
        path: '/dashboard',
        element: <DashboardPage />
    }
]

const NoLayoutSpaceRoutes: RouteObject[] = [
    {
        path: '/page/new',
        element: <PageDeviceProvider>
            <CreatePage />
        </PageDeviceProvider>
    },
    {
        path: '/page/edit/:id',
        element: <PageDeviceProvider>
            <CreatePage />
        </PageDeviceProvider>
    },
    {
        path: '/page/seo-geo/:id',
        element: <PageDeviceProvider>
            <SEODashboard />
        </PageDeviceProvider>
    },
    {
        path: '/agents/scouting-agent',
        element: <CreateScouting />
    },
    {
        path: '/agents/scouting-agent/superbrain',
        element: <Superbrain />
    },
    {
        path: '/form/edit/step/:id',
        element: <CreateForm />
    },
    {
        path: '/partner/new',
        element: <CreateUpdatePartner />
    },
    {
        path: '/partner/edit/:id',
        element: <CreateUpdatePartner />
    },
    {
        path: '/page/edit/new/:id',
        element: <CreatePageNew />
    },
    {
        path: '/course/edit/:id',
        element: <AddChapterToCourse />
    },
    {
        path: '/subscription/edit/:id',
        element: <AddMembersToSubscription />
    },
    {
        path: '/subscription/subscribe-field/new',
        element: <SubscribeFieldEditor />
    },
    {
        path: '/subscription/subscribe-field/edit/:id',
        element: <SubscribeFieldEditor />
    },
    {
        path: '/communication/edit/:id',
        element: <CreateCommunication />
    },
    {
        path: '/page/preview/:id',
        element: <PagePreview />
    },
    {
        path: '/newsletter/edit/:id',
        element: <CreateNewsletter />
    },
    {
        path: '/form/preview/:id',
        element: <FormPreview />
    },
    // {
    //     path: '/navigation/header/preview/:id',
    //     element: <HeaderPreview />
    // },
    {
        path: '/navigation/header/new',
        element: <CreateUpdateHeader />
    },
    {
        path: '/navigation/header/edit/:id',
        element: <CreateUpdateHeader />
    },
    {
        path: '/navigation/sidebar/edit/:id',
        element: <CreateUpdateSidebar />
    },
    {
        path: '/navigation/footer/edit/:id',
        element: <CreateUpdateFooter />
    },
    {
        path: '/navigation/footer/new',
        element: <CreateUpdateFooter />
    },
    {
        path: '/communication/new',
        element: <CreateCommunication />
    },
    {
        path: '/navigation/sidebar/new',
        element: <CreateUpdateSidebar />
    },
    {
        path: '/superadmin/blocks-data/edit/:id',
        element: <Edit />
    },
    {
        path: '/listing/edit/:id',
        element: <CreateListing />
    },
    {
        path: '/product/edit/:id',
        element: <CreateProduct />
    },
    {
        path: '/dataset/edit/:id',
        element: <CreateDataset />
    },
    {
        path: '/dataset/edit/feed/:id',
        element: <Feed />
    },
    {
        path: '/product-dataset/edit/:id',
        element: <CreateProductDataset />
    }
]

const NoLayoutAdminRoutes: RouteObject[] = [
    {
        path: '/page/new/templateId/:templateId',
        element: <PageDeviceProvider>
            <CreatePage />
        </PageDeviceProvider>
    },
    {
        path: '/newsletter/new/templateId/:templateId',
        element: <CreateNewsletter />
    },
    {
        path: '/form/step/new/templateId/:templateId',
        element: <CreateForm />
    },
    {
        path: '/member/edit/:id',
        element: <EditMember />
    },
    {
        path: '/tag/edit/:id',
        element: <CreateTag />
    },
    {
        path: '/aiprompt/edit/:id',
        element: <CreatAiPrompt />
    },
    {
        path: '/template/preview/:id',
        element: <CreateTemplate />
    },
    {
        path: '/form/step/new',
        element: <CreateForm />
    },
    {
        path: '/newsletter/new',
        element: <CreateNewsletter />
    },
    {
        path: '/template/new',
        element: <CreateTemplate />
    },
    {
        path: '/listing/new',
        element: <CreateListing />
    },
    {
        path: '/listing/content-agent',
        element: <ContentAgentListing />
    },
    {
        path: '/product/new',
        element: <CreateProduct />
    },
    {
        path: '/dataset/new',
        element: <CreateDataset />
    },
    {
        path: '/product-dataset/new',
        element: <CreateProductDataset />
    },
    {
        path: '/tag/new',
        element: <CreateTag />
    },
    {
        path: '/aiprompt/new',
        element: <CreatAiPrompt />
    }

]

const NoLayoutCommonRoutes: RouteObject[] = [
    {
        path: '/space/invite/:id',
        element: <SpaceInvite />
    },
    {
        path: '/onboarding',
        element: <Onboarding />
    },
]

const LayoutMainRoutes: RouteObject[] = [
    {
        element: (
            <AuthGuard>
                <MainLayout />
            </AuthGuard>
        ),
        children: [...LayoutAdminRoutes, ...LayoutSpaceRoutes, ...LayoutCommonRoutes]
    }
]

const NoLayoutMainRoutes: RouteObject[] = [
    {
        element: (
            <AuthGuard>
                <Outlet />
            </AuthGuard>
        ),
        children: [...NoLayoutAdminRoutes, ...NoLayoutSpaceRoutes, ...NoLayoutCommonRoutes]
    }
]

const AdminRoutes = NoLayoutAdminRoutes.concat(LayoutAdminRoutes)
const SpaceRoutes = NoLayoutSpaceRoutes.concat(LayoutSpaceRoutes)
const CommonRoutes = NoLayoutCommonRoutes.concat(LayoutCommonRoutes)
const LoginRoutes: RouteObject[] = [
    {
        path: '/login',
        element: <SignIn />
    },
    {
        path: '/create-account',
        element: <SignUp />
    }
]

const MainRoutes: RouteObject = {
    path: '/',
    children: [...NoLayoutMainRoutes, ...LayoutMainRoutes]
}

export { AdminRoutes, SpaceRoutes, CommonRoutes, LoginRoutes }
export default MainRoutes
